import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    list: {},
  }
}

const state = getDefaultState()

const mutations = {
  SET_MENU_LISTS(state, payload) {
    state.list = payload
  },
}

const actions = {
  async getList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.project-registration-application.list'), payload)
    if (apiResult && apiResult.data) {
      commit('SET_MENU_LISTS', apiResult.data)
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
